import { useState } from "react";

export function CodeStep({
  prompt,
  onSubmit,
  onCancel,
  isPending,
}: {
  prompt: string;
  onSubmit: (v: string) => void;
  onCancel: () => void;
  isPending: boolean;
}) {
  const [value, setValue] = useState("");
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(value);
      }}
      style={{ padding: 24 }}
    >
      <div className="iris-meta">{prompt}</div>
      <input
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        // biome-ignore lint/a11y/noAutofocus: Wizard step intentionally autofocuses the input.
        autoFocus
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="iris-input"
        style={{
          marginTop: 12,
          width: "100%",
          textAlign: "center",
          fontSize: 22,
          letterSpacing: 6,
        }}
      />
      <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "flex-end" }}>
        <button type="button" className="iris-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="iris-btn iris-btn--primary" disabled={!value || isPending}>
          Submit
        </button>
      </div>
    </form>
  );
}
